import { ValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/validation-message-resolver';
import { TranslateService } from '@ngx-translate/core';
import { Injectable, inject } from '@angular/core';
import { IrisUserTimePipe } from '@iris/common/modules/time';

@Injectable()
export class MaxDatetimeValidationMessageResolver implements ValidationMessageResolver<{ max: unknown }> {
  private readonly translateService = inject(TranslateService);
  private readonly irisUserTimePipe = inject(IrisUserTimePipe);

  readonly errorCode = 'matDatepickerMax';

  getMessage(error?: { max: unknown }): string {
    return this.translateService.instant('label.validation.max', { value: this.irisUserTimePipe.transform(error?.max) });
  }
}
